






















import Vue from 'vue';
import { Component, Provide } from 'vue-property-decorator';
import BulletinList from '@/components/ViewComponent/Bulletin/BulletinList/BulletinList.vue';
import CSideBar from '@/components/Layout/SideBar/CSideBar.vue';
import BtnCreateBulletin from '@/views/Bulletin/BtnCreateBulletin.vue';

@Component<Bulletin>({
  components: { BtnCreateBulletin, CSideBar, BulletinList },
})
export default class Bulletin extends Vue {
  sideDrawer: boolean = null;

  @Provide('toggleSideDrawer')
  toggleSideDrawer(): void {
    this.sideDrawer = !this.sideDrawer;
  }
}
